import createErrorType from '@/utils/createErrorType.js';

export const InvalidAuthTokenError = createErrorType('InvalidAuthTokenError');
